import JSCookies from 'js-cookie';

function get<T extends string | undefined>(key: T): T extends undefined ? { [key: string]: string } | undefined : string | undefined;
function get(key?: string) {
  return key ? JSCookies.get(key) : JSCookies.get();
}

const Cookies = {
  set: (key: string, value: string, options?: JSCookies.CookieAttributes) => JSCookies.set(key, value, options),
  get,
  remove: (key: string) => JSCookies.remove(key),
};

export default Cookies;
